import { NotificationBadge } from '@/features/shared/components/NotificationBadge'
import { CartIcon } from '@shipt/design-system-icons'
import { formatPrice } from '@/features/shared/utils/formatter'
import { NextLink } from '@/features/shared/elements/Link'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { routes } from '@shared/constants/routes'
import { useQueryCart } from '@/features/shop/services/Cart/queries'
import { IconButton } from '@shipt/design-system-buttons'
import { useEffect } from 'react'
import { medallia } from '@/lib/medallia'

export const CartButton = () => {
  const { data: cart } = useQueryCart()
  const { num_items = 0, requested_subtotal_with_fees = 0 } = cart ?? {}

  useEffect(() => {
    medallia.setParams({ cart_item_count: num_items })
  }, [num_items])

  const getFormattedSubtotal = (subtotal: number) => {
    return subtotal > 999 ? '$999+' : formatPrice(subtotal)
  }
  const formattedSubtotal = getFormattedSubtotal(requested_subtotal_with_fees)

  const ariaItemPlurality = num_items === 1 ? 'item' : 'items'
  const ariaCartSubtotal = requested_subtotal_with_fees > 0 ? formattedSubtotal + ' subtotal. ' : ''
  const handleOnClick = () => {
    trackElementClicked({
      type: 'link',
      link_name: 'cart_link',
      next_location: routes.CART.url,
      display_format: 'header',
    })
  }
  const ariaLabelText = `${num_items} ${ariaItemPlurality} in cart. ${ariaCartSubtotal}Click to view cart.`

  return (
    <NotificationBadge surface="inverse" value={num_items} ariaContext="cart">
      <IconButton
        icon={CartIcon}
        variant="tertiary"
        size="md"
        onClick={handleOnClick}
        aria-label={ariaLabelText}
        forwardedAs={NextLink}
        href={routes.CART.url}
      />
    </NotificationBadge>
  )
}
